import moment from 'moment';

// DatePicker默认的类型
export const DEFAULT_DATE = 'date';
// 季度
export const QUARTERS = ['一季度', '二季度', '三季度', '四季度'];
export const FORMATQUARTERS = ['一季度', '二季度', '三季度', '四季度'];
// 今年
export const CURRENT_YEAR = moment().startOf('year');
// 今天
export const CURRENT_DAY = moment().startOf('day');
// 昨天
export const LAST_DAY = moment().subtract(1, 'days');
// 当前月
export const CURRENT_MONTH_END = moment().startOf('month');
// 上个自然月
export const LAST_MONTH_START = moment().startOf('month').subtract(1, 'months');

// 日期格式
export const DATE_FORMAT = 'YYYY-MM-DD';
// 日期格式 - 月份
export const MONTH_FORMAT = 'YYYY-MM';

export const DEFAULT_WEEK_END = moment().startOf('isoWeek').subtract(1, 'days');
export const DEFAULT_WEEK_START = moment().startOf('isoWeek').subtract(7, 'days');

export const LAST_MONTH_END = moment().startOf('month').subtract(1, 'days');

// 过去一个月
export const PAST_MONTH = moment().subtract(1, 'months');

export const PICKER_OPTION = {
  date: '日',
  month: '月',
  quarters: '季',
  year: '年',
};
